var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgHangup = function SvgHangup(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.027 15.961c1.141 1.232 3.888 3.365 4.637 3.803l.151.09c1.143.679 4.722 2.807 7.33.815 2.021-1.542 1.364-3.278.684-3.794-.466-.362-1.838-1.36-3.128-2.26-1.268-.883-1.974-.175-2.452.303l-.026.026-.96.961c-.246.245-.618.156-.974-.125a26 26 0 0 1-2.692-2.385l-.004-.004c-.47-.47-1.4-1.4-2.373-2.68-.28-.356-.37-.728-.125-.973l.96-.961.027-.026c.478-.478 1.186-1.184.303-2.452-.9-1.29-1.898-2.662-2.26-3.128-.516-.68-2.252-1.337-3.794.684-1.992 2.608.136 6.187.815 7.33l.09.151c.438.75 2.56 3.484 3.791 4.625"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.697 3.078a.64.64 0 0 0 0-.893.615.615 0 0 0-.88 0L17 5.045l-2.817-2.86a.615.615 0 0 0-.88 0 .64.64 0 0 0 0 .893l2.817 2.86-2.938 2.984a.64.64 0 0 0 0 .893.615.615 0 0 0 .88 0L17 6.832l2.938 2.983a.615.615 0 0 0 .88 0 .64.64 0 0 0 0-.893L17.88 5.939z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHangup);
export { ForwardRef as Icon };
export default "img/element-icons/call/hangup.a9876fc.svg";